import React from 'react';
import { Award } from 'lucide-react';

// Glowing gold card shell + header used by the Home Valuation form.
export const ValuationCard = ({ headingLevel = 'h3', children }) => {
  const Heading = headingLevel;
  return (
    <div className="lg:ml-auto w-full max-w-lg animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
      <div className="relative">
        <div className="absolute -inset-6 bg-gradient-to-r from-gold-400/30 via-gold-500/20 to-gold-600/30 blur-3xl rounded-3xl animate-pulse"></div>
        <div className="relative bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border-4 border-gold-400/50 p-10">
          <div className="text-center mb-8 pb-6 border-b-2 border-gold-400/30">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-gold-400 to-gold-600 rounded-2xl shadow-2xl mb-4">
              <Award className="w-10 h-10 text-white" />
            </div>
            <Heading className="text-3xl font-serif font-black text-gray-900 mb-2">FREE Home Valuation</Heading>
            <p className="text-base font-bold text-[#143160]">Get Your Property Value in Minutes!</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
